const NAME = 'PLAN_SUBSCRIPTIONS_BULK_CREATE';

export const GOTO_NEXT_STEP = `${NAME}/GOTO_NEXT_STEP`;
export const GOTO_PREVIOUS_STEP = `${NAME}/GOTO_PREVIOUS_STEP`;
export const RESET_ASSIGN_STATE = `${NAME}/RESET_ASSIGN_STATE`;

export const RESET_VIEW = `${NAME}/RESET_VIEW`;
